import { render, staticRenderFns } from "./ZFNotice.vue?vue&type=template&id=36c6c4e0&scoped=true&"
import script from "./ZFNotice.vue?vue&type=script&lang=js&"
export * from "./ZFNotice.vue?vue&type=script&lang=js&"
import style0 from "./ZFNotice.vue?vue&type=style&index=0&id=36c6c4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c6c4e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/yicai/wanhuahengxin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDialog,VDivider,VIcon,VList,VListTile,VListTileTitle,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
